import React from 'react';
import { useTranslation } from 'react-i18next';
import { useDispatch, useSelector } from 'react-redux';
import apis from '@src/apis';
import { useParams } from 'react-router-dom';
import { Box, Button, Typography } from '@mui/material';
import actions from '@src/redux/actions';
import { NEW_AUDIO_STATUS } from '@src/constants/voiceCloning';
import { StyledSentenceList } from './index.style';

const SentenceList = ({ audiosArray, onSelectSentence }) => {
  const dispatch = useDispatch();
  const { voice: voiceRecording } = useSelector(
    (state) => state.voiceVoiceCloning,
  );
  const alreadyRecorded = voiceRecording?.submitAt;
  const { t } = useTranslation();
  const { voiceId } = useParams();

  const filterAudio = (audio) =>
    !(
      alreadyRecorded &&
      (audio.status === NEW_AUDIO_STATUS.PASSED ||
        audio.status === NEW_AUDIO_STATUS.GOOD ||
        (audio.status === NEW_AUDIO_STATUS.PENDING && !audio?.note))
    );

  const saveSelectedSentenceToVoice = async (sentence) => {
    if (!sentence) return;

    const voiceDataUpdate = {
      lastSentenceCode: sentence.code,
    };
    const response = await apis.voiceCloning.updateVoiceCloningVoice(
      voiceId,
      voiceDataUpdate,
    );
    if (!response?.status) {
      dispatch(
        actions.noti.push({
          severity: 'error',
          message: t('updateVoiceFailed'),
        }),
      );
    } else {
      const updatedVoiceInfo = {
        ...voiceRecording,
        lastSentenceCode: sentence.code,
      };
      dispatch(actions.voiceVoiceCloning.addVoice(updatedVoiceInfo));
    }
  };

  const handleSelectSentence = async (sentence) => {
    await saveSelectedSentenceToVoice(sentence);
    onSelectSentence();
  };

  const renderStyleSentenceBtn = ({ status, quality, audioLink }) => {
    if (status === NEW_AUDIO_STATUS.FAILED) return 'failed';
    if (!audioLink) return 'disabled';

    const isPassedQuality = Object.values(quality).every(Boolean);
    if (isPassedQuality) return 'passed';

    return 'failed';
  };

  return (
    <StyledSentenceList>
      <Box className="box-sentence-list">
        <Typography className="title">{t('sentenceList')}</Typography>
        <Box className="sentences">
          {audiosArray.map((audio, index) => {
            if (!filterAudio(audio)) return null;

            return (
              <Button
                className={`sentence-btn ${renderStyleSentenceBtn({
                  status: audio?.status,
                  quality: audio?.quality,
                  audioLink: audio?.audioLink,
                })}`}
                key={audio.id}
                onClick={() => {
                  handleSelectSentence(audio?.sentence);
                }}
              >
                {index + 1}
              </Button>
            );
          })}
        </Box>
      </Box>
    </StyledSentenceList>
  );
};

export default SentenceList;
